import DatePicker from './date-picker.js';
import Select from './select.js';
import Calendar from './calendar.js';

if (!customElements.get('aeon-select')) {
    customElements.define('aeon-select', Select);
}
if (!customElements.get('aeon-calendar')) {
    customElements.define('aeon-calendar', Calendar);
}
if (!customElements.get('aeon-datepicker')) {
    customElements.define('aeon-datepicker', DatePicker);
}
